/* eslint-disable no-tabs */
import { Avatar, Divider, Flex } from '@chakra-ui/react'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ModalBase } from '../../../../../components/ModalBase'
import { iNomeId } from '../../../../../interfaces'

interface props {
  isOpen: boolean
  onRequestClose: () => void
  reunioes: iNomeId[]
}

export const ModalReunioes: React.FC<props> = ({ isOpen, onRequestClose, reunioes }) => {
  function ObterNomeStatus(status: number): string {
    switch (status.toString()) {
      case '0':
        return 'Aguardando'
      case '1':
        return 'Aceita'
      case '2':
        return 'Recusada'
      case '3':
        return 'Reagendada'
      case '4':
        return 'atrasada'
      case '5':
        return 'Finalizada'
      case '6':
        return 'Agendamento'
      default: return ''
    }
  }

  function ObterCorStatus(status: number): string {
    switch (status.toString()) {
      case '0':
        return 'var(--Gray3)'
      case '1':
        return 'var(--Azul)'
      case '2':
        return 'var(--Rosa)'
      case '3':
        return 'var(--Purple1)'
      case '4':
        return 'var(--Red)'
      case '5':
        return 'var(--Green3)'
      case '6':
        return 'var(--Orange)'
      default: return ''
    }
  }

  return (
        <ModalBase
            isOpen={isOpen}
            onClose={onRequestClose}
            Titulo={'Status por reunião'}
            Width='52rem'
        >
            <Flex flexDir={'column'} gap={'.875rem'} px={'1rem'} pt={'1.25rem'} maxH={'85vh'} overflowY={'auto'}>
              {reunioes.map(e => {
                return <Flex px={'2rem'} border={'1px solid var(--c6)'} py={'1rem'}>
                  <Flex gap={'.5rem'} alignItems={'center'} w={'100%'} pr={'1rem'}>
                    <Avatar src={e.avatar} size={'sm'}/>
                    <Flex gap={'.5rem'} lineHeight={'16px'} alignItems={'center'} fontSize={'14px'}>
                      <strong>{e.nome}</strong>
                      <Divider h={'2rem'} orientation={'vertical'} mx={'1.25rem'} opacity={'.9'} borderColor={'var(--c6)'}/>
                      <Flex
													borderRadius={'6px'}
													color={'#fff'}
													bgColor={ObterCorStatus(e.nota ?? 0)}
													px={'.5rem'} py={'.325rem'}
													fontSize={'14px'}
                          alignItems={'center'}
													fontWeight={'600'}
												>
													{ObterNomeStatus(e.nota ?? 0)}
												</Flex>
                    </Flex>
                  </Flex>
                </Flex>
              })}
            </Flex>
            <Flex justifyContent={'center'} gap={'1rem'} p={'1rem'}>
                <ButtonCmp VarColor='c6' onClick={onRequestClose}>Fechar</ButtonCmp>
            </Flex>

        </ModalBase>
  )
}
